import type { ReactNode } from "react";

/**
 * The available interaction modes for the chart
 */
export enum ChartMode {
  Pan = "pan",
  Zoom = "zoom",
  Select = "select",
  AddFitting = "addFitting",
  RemoveFitting = "removeFitting",
  RenameFitting = "renameFitting",
}

/**
 * Properties for modebar button components
 */
export interface ModebarButtonProps {
  active?: boolean;
  onClick?: () => void;
  tooltip?: string;
  disabled?: boolean;
  translate?: string;
}

/**
 * The available positions for the modebar
 */
export type ModebarPosition = "top-left" | "top-right" | "bottom-left" | "bottom-right";

/**
 * Properties for the modebar component
 */
export interface ModebarProps {
  className?: string;
  children?: ReactNode;
  position?: ModebarPosition;
}
